// ─── UI phase states ──────────────────────────────────────────────────────────
// Drives the top-level v-if/v-else-if chain in VideoRoom.vue.
export const VIDEO_PHASES = {
  LOBBY:        'lobby',
  CONNECTING:   'connecting',
  CONNECTED:    'connected',
  RECONNECTING: 'reconnecting',
  WAITING:      'waiting',
  DENIED:       'denied',
  ENDED:        'ended',
  ERROR:        'error',
};

// ─── Vuex store connection lifecycle ─────────────────────────────────────────
// moduleVideo.js `connectionStatus` state; committed via SET_CONNECTION_STATUS.
export const CONNECTION_STATUS = {
  IDLE:         'idle',
  CONNECTING:   'connecting',
  CONNECTED:    'connected',
  RECONNECTING: 'reconnecting',
  DISCONNECTED: 'disconnected',
  ERROR:        'error',
};

// ─── Participant roles (lobby role selector) ──────────────────────────────────
// LobbyScreen.vue role <v-select>; determines token path and redirect logic.
export const PARTICIPANT_ROLES = {
  HOSPITAL_WORKER: 'Hospital Worker',
  PATIENT:         'Patient',
};

// ─── Participant types (database records) ────────────────────────────────────
// Written by video.controller.js as `participant_type` on video_participants rows.
export const PARTICIPANT_TYPES = {
  USER:  'user',
  GUEST: 'guest',
};

// ─── Room statuses ────────────────────────────────────────────────────────────
// video.controller.js writes these to video_rooms.status;
// VideoRoom.vue reads roomStatus from getRoomStatus / getPublicRoomStatus.
export const ROOM_STATUSES = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

// ─── Recording statuses ───────────────────────────────────────────────────────
// video.controller.js writes these to video_recordings.status;
// used in startRecording, stopRecording, webhook handler, and download guards.
export const RECORDING_STATUSES = {
  RECORDING: 'recording',
  COMPLETED: 'completed',
};

// ─── MediaDevices API kind strings ───────────────────────────────────────────
// LobbyScreen.vue filters enumerateDevices() results by these kind values.
export const DEVICE_KINDS = {
  AUDIO_INPUT:  'audioinput',
  VIDEO_INPUT:  'videoinput',
  AUDIO_OUTPUT: 'audiooutput',
};

// ─── LiveKit data channel message types ──────────────────────────────────────
// VideoRoom.vue DataReceived handler and _broadcastRecordingState use this type.
export const DATA_MESSAGE_TYPES = {
  RECORDING_STATE: 'recording_state',
};

// ─── Participant identity prefixes ────────────────────────────────────────────
// VideoRoom.vue uses these to identify screen-share tiles and waiting guests.
export const IDENTITY_PREFIXES = {
  SCREEN_SHARE: 'ss:',
  GUEST:        'guest-',
};

// ─── Session storage keys ─────────────────────────────────────────────────────
// LobbyScreen.vue stores the post-login redirect target under this key.
export const SESSION_STORAGE_KEYS = {
  POST_LOGIN_REDIRECT: 'postLoginRedirect',
};

// ─── MediaDevices permission error names ─────────────────────────────────────
// LobbyScreen.vue initDevices() catches getUserMedia errors by name.
export const MEDIA_ERROR_NAMES = {
  NOT_ALLOWED:       'NotAllowedError',
  PERMISSION_DENIED: 'PermissionDeniedError',
  NOT_FOUND:         'NotFoundError',
};

// ─── Frontend route paths ─────────────────────────────────────────────────────
// VideoRoom.vue navigation (goBack, Disconnected handler) and
// LobbyScreen.vue onRoleSelected redirect.
export const ROUTE_PATHS = {
  VIDEO_CALL_BASE: '/#/video-call/',
  CONVERSATION:    '/conversation',
  MEETING_ENDED:   '/meeting-ended',
};
